import LC from "@/repositories/lisacomunica/lc";

export default {
  // Email
  index(queryString) {
    let resource = `/logs/all`;
    return queryString
      ? LC.get(`${resource}?${queryString}`)
      : LC.get(`${resource}`);
  },
  show(id) {
    let resource = `/logs`;
    return LC.get(`${resource}/${id}`);
  },
  // Rimette in coda i messaggi falliti della procedura: { procedure_id }
  retry(payload) {
    let resource = `/logs/retry`;
    return LC.post(`${resource}`, payload);
  },
};
